import { call, select, put } from 'redux-saga/effects'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import get from 'lodash/get'

import request from 'store/request'
import { getIdentityAccessToken } from 'store/entities/identity/selectors'
import { forceLogoutRequest, AUTH_URL } from 'store/entities/identity/actions'
import { GET } from 'app/constants/requests'
import { sendError } from 'store/entities/analytics/actions'
import { showError, showInfo } from 'store/entities/toastr/utils'

export default function* makeAPIRequest(path, config, external, isShowError = true, isShowInfo = false) {
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode
  const accessToken = yield select(getIdentityAccessToken)
  config.headers = config.headers || {}
  if (!external && accessToken) {
    config.headers.Authorization = 'JWT ' + accessToken
    if (isIE11 && config.method === GET) {
      config.headers['Cache-Control'] = 'no-store'
      config.headers.Pragma = 'no-cache'
      config.headers.Expires = 0
    }
  }

  try {
    yield put(showLoading())
    const response = yield call(makeRequest, path, config)
    yield put(hideLoading())
    return response
  } catch (error) {
    yield put(hideLoading())
    yield put(sendError(error))
    if (error && error.response) {
      const { response } = error
      if (isShowError) {
        showError({
          content: get(response, ['data', 'message']),
        })
      }
      if (isShowInfo) {
        showInfo({
          content: get(response, ['data', 'message']),
        })
      }
      if (response.status === 401 && path !== AUTH_URL) {
        yield put(forceLogoutRequest())
      }
      throw response
    } else {
      throw error
    }
  }
}

async function makeRequest(path, config) {
  return request(path, { ...config })
}

export function getResponseBody(res) {
  return res.data
}

export function getResponseData(body) {
  return body.data
}
